<template>
  <div id="contenedor-configuracion-plantillas-generador-listado-desktop">
    <template v-if="listItem">
      <v-list-item
        v-if="mixValidaScopesActions(1)"
        @click="seleccionarPlantilla(nombrePlantilla)" link>
        <v-list-item-icon>
          <v-icon> mdi-file-word </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> {{ titulo }} </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-else>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="mixValidaScopesActions(1)"
            icon
            v-bind="attrs"
            v-on="on"
            @click="seleccionarPlantilla(nombrePlantilla)">
            <v-icon> fa-file-word </v-icon>{{etiqueta}}
          </v-btn>
        </template>
        <span> Word </span>
      </v-tooltip>
    </template>

  </div>
</template>

<script>
import PLANTILLA_POR_MODULO from '@/graphql/querys/administracion/configuracion/plantillas/plantillaPorModulo.gql';
// import CustomButton from '@/components/buttons/Button.vue';
// import FechaHumano from '@/components/FechaHumano.vue';
import mixGenerarPlantilla from '@/helpers/mixGenerarPlantilla';

export default {
  name: 'ConfiguracionPlantillasGeneradorListadoDesktop',
  mixins: [mixGenerarPlantilla],
  props: {
    titulo: {
      type: String,
      required: false,
      default: '',
    },
    listItem: {
      type: Boolean,
      required: false,
      default: false,
    },
    modulo: {
      type: String,
      required: true,
    },
    datos: {
      type: Object,
      required: true,
    },

    nombreArchivo: {
      type: String,
      required: false,
      default: 'plantilla',
    },
    nombrePlantilla: {
      type: String,
      required: false,
      default: '',
    },
    etiqueta: {
      type: String,
      required: false,
      default: '',
    },
  },
  components: {
    //   FechaHumano,
    // CustomButton,

  },
  data() {
    return {
      plantilla: Object,
      mostrarLoading: null,
      datosConFormato: Object,
      plantillaBusca: '',

    };
  },
  methods: {
    // Llama a mixGenerarPlantilla del microservicio de word
    async generaWord() {
      const datosConFormato = this.datos;
      const nombrePlantilla = this.plantilla.path;
      const nombreArchivoGenerado = `${this.nombreArchivo}`;
      // console.log('genera--> ', datosConFormato, nombrePlantilla, nombreArchivoGenerado);
      await this.mixGenerarPlantilla({
        data: {
          plantilla: nombrePlantilla,
          datos: datosConFormato,
        },
      }, nombreArchivoGenerado);
      this.mostrarLoading = null;
    },
    seleccionarPlantilla(plantilla) {
      this.plantillaBusca = plantilla;
      // console.log('--> ', Object.keys(this.getPlantilla).length, plantilla, this.getPlantilla);
      if (Object.keys(this.getPlantilla).length > 0) {
        this.plantilla = this.getPlantilla;
        // this.mostrarLoading = plantilla.id;
        this.generaWord();
      }
    },
  },
  apollo: {
    plantillaPorModulo: {
      query: PLANTILLA_POR_MODULO,
      variables() {
        return {
          modulo: this.modulo,
        };
      },
    },
  },
  computed: {
    getPlantilla() {
      if (!this.plantillaPorModulo || this.plantillaBusca === '') {
        return [];
      }
      return this.plantillaPorModulo
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .find(
          (p) => (p.nombre.toUpperCase().includes(this.plantillaBusca.toUpperCase())),
        ) || {};
    },
  },

};

</script>

<style lang="scss">

</style>
